import { createAction, props } from '@ngrx/store';
import { Author } from 'src/app/shared/interface/author';


// Load Authors
export const LOAD_AUTHORS = '[Audit] Load Authors';
export const LOAD_AUTHORS_SUCCESS = '[Audit] Load Authors Success';
export const LOAD_AUTHORS_FAIL = '[Audit] Load Authors Fail';

export const loadAuthors = createAction(
  LOAD_AUTHORS,
  props<{ authors: Author[] }>()
);

export const loadAuthorsSuccess = createAction(
  LOAD_AUTHORS_SUCCESS,
  props<{ payload: any }>()
);

export const loadAuthorsFail = createAction(
  LOAD_AUTHORS_FAIL,
  props<{ payload: any }>()
);

// Load Next Audit
export const LOAD_NEXT_AUDIT = '[Audit] Load Next Audit';
export const LOAD_NEXT_AUDIT_SUCCESS = '[Audit] Load Next Audit Success';
export const LOAD_NEXT_AUDIT_FAIL = '[Audit] Load Next Audit Fail';

export const loadNextAudit = createAction(
  LOAD_NEXT_AUDIT,
  props<{
    authorsList: string;
    company: string;
    product: string;
    date_in: string;
    date_out: string;
    analisis: string;
    loading: boolean;
  }>()
);

export const loadNextAuditSuccess = createAction(
  LOAD_NEXT_AUDIT_SUCCESS,
  props<{ payload: any; loaded: boolean }>()
);

export const loadNextAuditFail = createAction(
  LOAD_NEXT_AUDIT_FAIL,
  props<{ payload: any }>()
);

export const SELECT_DOCUMENT = '[Audit] Select doc';
export const SUCCESS_POST_ACTION = '[Audit] Success Post action';
export const ERROR_POST_ACTION = '[Audit] Error Post action';
export const RELOAD_AUDIT = '[Audit] Reload Audit';
export const CHANGE_FIELD_VALUE = '[Audit] Change field value action';
export const ALLOW_FIELD_CHANGE = '[Audit] Allow Change action';
export const APPROVE_FIELD = '[Audit] Approve field action';
export const REPROVE_FIELD = '[Audit] Reprove field action';
export const SELECT_IMAGE = '[Audit] Select Image action';
export const REPROVE_IMAGE = '[Audit] Reprove Image action';
export const APPROVE_IMAGE = '[Audit] Approve Image action';
export const TIME_OUT_ACTION = '[Audit] Time out action';
export const FINISH_AUDIT_ACTION = '[Audit] Finish audit action';
export const START_AUDIT_ACTION = '[Audit] Set Start Audit';
export const MAKE_STATISTICS_ACTION = '[Audit] Make Statistics Action';
export const SUCCESS_RELOAD_ACTION = '[Audit] Success Reload action';

export const loadCompanies = createAction(
  '[Audit] Load Companies',
  props<{ companies: any[] }>()
);

export const selectDoc = createAction(
  SELECT_DOCUMENT,
  props<{ key: string; step: string; button: string }>()
);

export const reloadAudit = createAction(RELOAD_AUDIT);

export const successReloadAction = createAction(
  SUCCESS_RELOAD_ACTION,
  props<{ payload: any }>()
);

export const changeFieldValue = createAction(
  CHANGE_FIELD_VALUE,
  props<{ value: any; target: string }>()
);

export const allowFieldChange = createAction(
  ALLOW_FIELD_CHANGE,
  props<{ target: string }>()
);

export const approveField = createAction(
  APPROVE_FIELD,
  props<{ target: string }>()
);

export const reproveField = createAction(
  REPROVE_FIELD,
  props<{ target: string }>()
);

export const selectImage = createAction(
  SELECT_IMAGE,
  props<{ target: string; key: string; button: string }>()
);

export const reproveImage = createAction(
  REPROVE_IMAGE,
  props<{ target: string; reasons: string[]; note: string }>()
);

export const approveImage = createAction(
  APPROVE_IMAGE,
  props<{ target: string }>()
);

export const timeOutAction = createAction(TIME_OUT_ACTION);

export const finishAuditAction = createAction(FINISH_AUDIT_ACTION);

export const makeStatisticsAction = createAction(MAKE_STATISTICS_ACTION);

export const startAudit = createAction(START_AUDIT_ACTION);

export const successPostAction = createAction(
  SUCCESS_POST_ACTION,
  props<{ payload: any }>()
);

export const errorPostAction = createAction(
  ERROR_POST_ACTION,
  props<{ error: any }>()
);
